module.exports = __webpack_public_path__ + "img/scale-color.ba059ea4.svg";